export const TennisHdpDouble = `
{{var period = parseInt(data.period);}}
{{var favouritePeriod = data.favouritePeriod;}}
{{var firstPeriod = period > 0 ? period : 0;}}
{{var event_count = 0;}}
{{var isLiveEvent = data.isLiveEvent;}}
{{? data.sports}}
{{~data.sports :sp:sp_index}}
{{var sportGroup =SportGroup.stringOf(sp[4]).toLowerCase();}}
{{var ot = data.ot;}}
{{var isParlay = (data.isParlay || data.isParlayMarket);}}
{{var isEsport = sp[0] == 12;}}
{{var sportName = sp[1];}}
{{var isShowLiveTv = data.isShowLiveTv;}}
{{var isEnableSignUp = data.isEnableSignUp;}}
{{var isBlockedLiveSport = data.isBlockedLiveSport;}}
{{var blockedLiveLeagues = data.blockedLiveLeagues;}}
{{var periodsRightLayout = data.periodsRightLayout;}}
{{var isBrandSupportLiveCenter = data.isBrandSupportLiveCenter;}}
{{var altMainLabel = data.altMainLabel;}}
{{var periodsDescription = data.periodsDescription;}}

<div class='double-line  {{? data.favourite}} fav-container {{?}}'>
    <div class="freeze-table-header"></div>
    <table class="events events-header sp{{=sp[0]}}">
        <tr>
        <td class="col-icons main-icons border-left border-bottom col-border-left" rowspan="2"></td>
        <td class="col-time main-time border-bottom-right" rowspan="2">{{=i18n('Time')}}</td>
        <td class="col-fav main-fav border-bottom" rowspan="2"></td>
        <td class="col-name main-name period-layout border-bottom-right" rowspan="2"><span>{{=i18n('Event')}}</span></td>
        <td colspan="3" class="main-fulltime border-bottom-right">{{=i18n('Sets')}}</td>
        <td colspan="3" class="main-halftime border-bottom">{{=i18n('Games')}}</td>
        <td class="col-more main-more border-bottom-right border-left col-border-right" rowspan="2"></td>
        </tr>
        <tr>
            {{? period > 0 || !isEsport}}
                <td class="col-1x2 main-1x2 border-bottom-right">{{=i18n(sportGroup, '1x2')}}</td>
                <td class="col-hdp main-hdp border-bottom-right">{{=i18n('HDP')}}</td>
                <td class="col-ou main-ou border-bottom-right">{{=i18n('OU')}}</td>
                <td class="col-1x2 main-1x2 border-bottom-right">{{=i18n(sportGroup, '1x2')}}</td>
                <td class="col-hdp main-hdp border-bottom-right">{{=i18n('HDP')}}</td>
                <td class="col-ou border-bottom">{{=i18n('OU')}}</td>
            {{??}}
                <td class="col-1x2 main-1x2 border-bottom-right">{{=i18n('others', 'e_1x2')}}</td>
                <td class="col-hdp main-hdp border-bottom-right">{{=i18n('others', 'e_HDP')}}</td>
                <td class="col-ou main-ou border-bottom-right">{{=i18n('OU')}}</td>
               
            {{?}}
        </tr>
    </table>
    {{var leagues = sp[2];}}
    {{var images = {};}}
    {{~leagues :lg:lg_index}}
    {{var leagueName = lg[1];}}
    {{var leagueId = lg[0];}}
    {{var isBlockedLiveLeague = blockedLiveLeagues.indexOf(leagueId) > -1;}}
    <div class="league" id='lg{{=leagueId}}'>
        <a class="bookmark "><i data-league-id="{{=leagueId}}" class='fav  icon'></i></a>
        <div class="fav-custom-tooltip ">
            <div class="tooltip-wrapper">
                <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
            </div>
        </div>
        <span>
        {{var originalLeagueName = lg[4] ? lg[4] : leagueName;}}
        {{=leagueName}}
        </span>
        <a class="refresh-odds" data-live="{{=data.isLive}}"><i class='icon refresh-odds'></i></a>
    </div>
    <div>
    {{var events = lg[2] || [];}}
    {{var eParentLeague = fetchParentId(events);}}
    {{var parentEvents = events.filter(function(e){ return e[28]==0});}}
    {{var notParentEvents = events.filter(function(e){ return e[28] != 0});}}
    {{~eParentLeague :parentEvent:parentEventIndex}}
      {{var evParent = parentEvents.find(function(ev) {return ev[0] === parentEvent}) || [];}}
      {{var childEvents = notParentEvents.filter(function(e){ return e[28] === parentEvent});}}
      {{var isSetChildEvent = childEvents.some(function(ev){ return ev[28] === parentEvent && ev[27] === "Sets";});}}
      {{var isGameChildEvent = childEvents.some(function(ev){ return ev[28] === parentEvent && ev[27] === "Games";});}}
      {{var isRegularChildEvent = childEvents.some(function(ev){ return ev[28] === parentEvent && ev[27] === "Regular";});}}
      {{? evParent.length === 0 && !isRegularChildEvent}}
        {{evParent = notParentEvents.find(function(ev) { return ev[28] === parentEvent && (ev[27] === "Sets");}) || [];}}
        {{childEvents = notParentEvents.filter(function(ev) { return ev[28] === parentEvent && ev[27] === "Games";});}}        
      {{?}}
      {{var groupEvents = events.filter(function(e){ return e[28] === parentEvent || e[0] === parentEvent});}}
      {{var periods = groupEvents.reduce(function(pe, e){ return pe.concat(Object.keys(e[8]));}, []);}}
      {{var finalPeriods = data.favourite && favouritePeriod ? [favouritePeriod] : [...new Set(periods)];}}
      {{var hasMatchPeriod = finalPeriods.length && finalPeriods[0] === '0';}}
      {{~finalPeriods :p:pIndex}}
      {{? childEvents.length > 0 }}
        {{var childEventSamePeriod = childEvents.filter(function(e){ return Object.keys(e[8]).includes(p);});}}
        {{? (isSetChildEvent && !isGameChildEvent) || (childEvents.length > 0 && evParent.length > 0 && childEventSamePeriod.length === 0  && Object.keys(evParent[8]).includes(p))}}
            {{childEventSamePeriod.unshift(evParent);}}
        {{?}}
      {{??}}
        {{var childEventSamePeriod = [evParent];}}
      {{?}}
      {{~childEventSamePeriod :ev:evIndex}}
          {{var isLastestEvent = finalPeriods.length > 1 && finalPeriods.length === pIndex + 1 && isLiveEvent;}}
          {{var {isRegularEvent, isSetEvent, isGameEvent, isRegularEventParent, isSetEventParent, isGameEventParent} = getTypeEventTennis(ev, evParent);}}
          {{var evSetsId = getEventSetsId(evParent, ev);}}
          <table class="events tennis no-select sp{{=sp[0]}} pe{{=ev[28]}} {{= p !=='0' && isLiveEvent && hasMatchPeriod ? "isNotMatch hide" : ""}}" id="e{{=ev[0]}}" lines="{{=ev[3]}}">
              {{var event_count = event_count + 1;}}
              {{var sets = isSetEvent ? ev[8][p] || [] : (isSetEventParent || isRegularEventParent ? evParent[8][p] || [] : []);}}
              {{var regular = isRegularEvent ? ev[8][p] || [] : (isRegularEventParent && !isSetEvent ? evParent[8][p] || [] : [] );}}
              {{var setHDP = !isRegularEvent && sets && sets[0] || [];}}
              {{var setOU =  !isRegularEvent && sets && sets[1] || [];}}
              {{? !isSetEvent && (isRegularEvent || isRegularEventParent)}}
                {{var setML = regular && regular[2] || [];}}
              {{??}}
                {{var setML = sets && sets[2] || [];}}
              {{?}}
              {{var haftTimePeriods =  {};}}

              {{?isGameEventParent && !isGameEvent}}
                {{haftTimePeriods["ht" + p] = evParent[8][p];}}
              {{?}}

              {{?isGameEvent || isRegularEvent }}
                {{haftTimePeriods["ht" + p] = ev[8][p];}}
              {{??}}
                {{haftTimePeriods["ht" + p] = [];}}
              {{?}}
              
              {{var games = isGameEvent ? ev[8][p] : (isGameEventParent || (isRegularEventParent && !isSetEvent) ? evParent[8][p] : []);}}
          
              {{var haftTimeLines = {};}}
              {{~Object.keys(haftTimePeriods) :htKey:ht_index}}
                {{haftTimeLines[htKey + "HDP"] = (haftTimePeriods[htKey][0] || []);}}
                {{haftTimeLines[htKey + "OU"] = (haftTimePeriods[htKey][1] || []);}}
                {{haftTimeLines[htKey + "ML"] = (haftTimePeriods[htKey][2] || []);}}
              {{~}}
              {{var gamesHDP = haftTimeLines["ht" + p + "HDP"] || [];}}
              {{var gamesOU = haftTimeLines["ht" + p + "OU"] || [];}}
      
              {{var indexMainLineSetsHDP = sets && sets[7]&& sets[7][0] || 0;}}
              {{var indexMainLineSetsOU = sets && sets[7] && sets[7][1] || 0;}}
              {{var indexMainLineGamesHDP = isRegularEvent ? regular && regular[7] && regular[7][0] || 0 : games && games[7] && games[7][0] || 0;}}
              {{var indexMainLineGamesOU = isRegularEvent ? regular && regular[7] && regular[7][1] || 0 : games && games[7] && games[7][1] || 0;}}
              {{var _moreBetsCount = (evParent && evParent.length > 0 && evParent[0] !== ev[0]) ? evParent[7] + ev[7] : ev[7];}}
              {{? period === 0 && !data.favourite}}
                {{var periodEvent = evParent && evParent[0] !== ev[0] && ev[8] && ev[8][p] ? ev[8][p] : 0;}}
                {{var parentPeriod = evParent && evParent[8] && evParent[8][p] ? evParent[8][p] : 0;}}
                {{var periodEventCount = periodEvent && periodEvent[8] ? periodEvent[8] : 0;}}
                {{var parentPeriodEventCount = parentPeriod && parentPeriod[8] ? parentPeriod[8] : 0;}}
                {{_moreBetsCount = parseInt(periodEventCount) + (evParent.length > 0 ? parseInt(parentPeriodEventCount) : 0);}}
              {{?}}
              {{var indexMainLine = Math.max(indexMainLineSetsHDP, indexMainLineSetsOU, indexMainLineGamesHDP, indexMainLineGamesOU, 0);}}
              {{var numberOfDisplayedLine = Math.min(Math.max(setHDP.length, setOU.length, gamesHDP.length, gamesOU.length), data.maxLines);}}
      
              {{var minLine = ev[3] > 0 ? Math.min(ev[3], data.maxLines) : data.maxLines;}}
              {{var lines = new Array().init(numberOfDisplayedLine > 0 ? Math.min(minLine, data.maxLines, numberOfDisplayedLine) : minLine);}}
              {{var isRegularLeft = regular && regular[2];}}
              {{var isRegularRight = (regular && regular[0]) || (regular && regular[1]);}}
              {{var statusPeriodLeftSide = (sets && sets[11]) || (isRegularLeft && regular[11]) ? "status_" + (sets[11] || regular[11]) : "";}}
              {{var statusPeriodRightSide = (games && games[11]) || (isRegularRight && regular[11]) ? "status_" + (games[11] || regular[11]) : "";}}
              {{var setEventId =  ((isRegularEvent && isRegularLeft) || isSetEvent) ? ev[0] : ((isRegularEventParent && isRegularLeft) || isSetEventParent) ? evParent[0] : 0;}}
              {{var gameEventId = ((isRegularEvent && isRegularRight) || isGameEvent) ? ev[0] : ((isRegularEventParent && isRegularRight) || isGameEventParent) ? evParent[0] : 0;}}
              {{~lines :line:line_index}}
              {{var _sethdp = setHDP.length > (line - (indexMainLine - indexMainLineSetsHDP)) && (line - (indexMainLine - indexMainLineSetsHDP)) >= 0 && setHDP[line - (indexMainLine - indexMainLineSetsHDP)];}}
              {{var _setou = setOU.length > (line - (indexMainLine - indexMainLineSetsOU)) && (line - (indexMainLine - indexMainLineSetsOU)) >= 0 && setOU[line - (indexMainLine - indexMainLineSetsOU)];}}
              {{var _gameshdp = gamesHDP.length > (line - (indexMainLine - indexMainLineGamesHDP)) && (line - (indexMainLine - indexMainLineGamesHDP)) >= 0 && gamesHDP[line - (indexMainLine - indexMainLineGamesHDP)];}}
              {{var _gamesou = gamesOU.length > (line - (indexMainLine - indexMainLineGamesOU)) && (line - (indexMainLine - indexMainLineGamesOU)) >= 0 && gamesOU[line - (indexMainLine - indexMainLineGamesOU)];}}
              {{var isMainLine = (line == indexMainLine);}}
              {{var _gamesML = isMainLine && (haftTimeLines["ht" + p + "ML"] || haftTimeLines["ht" + p + "ML"]  || haftTimeLines["ht" + p + "ML"]);}}
              {{var _setML = isMainLine && setML && (setML[0] !== '' || setML[1] !== '');}}
              {{var isOnlyML = numberOfDisplayedLine == 0 && (_gamesML || _setML);}}
              {{var numberLine = (!isMainLine && line_index == 0) || lines.length >= 2 ? lines.length : 1;}}
              {{var isValidPeriod = (_sethdp || _setou || (_gameshdp && (_gameshdp[2] || _gameshdp[3]))  || (_gamesou && (_gamesou[2] || _gamesou[3])) || _setML);}}      
              {{? isValidPeriod || (line === 0 && (_setML || _moreBetsCount > 0))}}
              {{var hasDrawML = sp[7] && ((regular && regular[2] && regular[2][2]) || (sets && sets[2] && sets[2][2]) || (games && games[2] && games[2][2]));}}
              {{var teamNameEv1 = evParent.length > 0 && !isSetEvent ? evParent[1] :ev[1];}}
              {{var teamNameEv2 = evParent.length > 0 && !isSetEvent ? evParent[2] :ev[2];}}
              <tr class='{{=parentEventIndex%2==0?"odd":"even"}} mkline tennis-odds-line {{=isMainLine && hasDrawML ? "main-line-draw" : ""}} e{{=isSetEventParent ? evParent[0] : ev[0]}}_{{=p}}' 
                  id="e{{=isSetEventParent ? evParent[0] : ev[0]}}_{{=_sethdp[8] ? _sethdp[8] : _gameshdp[8] }}_{{=p}}" {{? _moreBetsCount > 0}} data-eid="{{=evParent && evParent[0] && evParent[0] != ev[0] ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}" {{?}} data-pid="{{=p}}">
                  <td class='col-icons  main-icons border-left col-border-left {{=(lines.length - 1 == line_index) ? "border-bottom" : ""}}'>
                  </td>
                      {{?line_index == 0}}
                          <td class='col-time main-time {{=(lines.length - 1 == line_index) ? "border-bottom-right" : "border-right"}}' total-lines='{{=lines.length}}' rowspan='{{=isOnlyML ? 1 : numberLine}}'>
                          {{? ev[5]}}
                              {{? ev[9]}}
                              <span>{{=ev[9][0]}}-{{=ev[9][1]}}</span>
                              {{??}}
                                  {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                              {{?}}
                              {{? ev[16]}}
                              <span class='liveInfo'>{{=i18n(ev[16])}} {{=ev[15]||''}}</span>
                              {{??}}
                              <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                              {{?}}
                          {{??}}
                              {{? ev[6] && !isBlockedLiveSport && !isBlockedLiveLeague}}
                                  <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                                  {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                              {{??}}
                                  <span>{{=moment(new DateTZ(ev[4])).format(i18n('MM/DD'))}}</span>
                                  <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                              {{?}}
                          {{?}}                    
                          </td>
                      {{?}}
                  <td class='col-fav  main-fav border-bottom'>
                      {{? isMainLine}}
                          <a class="bookmark" data-event-id="{{=evParent[0] || 0 }}_{{=ev[0]}}_{{=p}}" ><i class='fav  icon'></i></a>
                          <div class="fav-custom-tooltip ">
                              <div class="tooltip-wrapper">
                                  <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
                              </div>
                          </div>
                      {{?}}
                  </td>
                  <td class='{{=(_sethdp || _gameshdp) && (_sethdp[6]||_sethdp[5]||_gameshdp[5]||_gameshdp[6]) ? "": "no-underdog"}} col-name  main-name period-layout {{=ev[18] && ev[19] ? "lc-icons": ev[19] ? "live-tv": ev[18] ?  "live-c" : ""  }} border-bottom-right'
                    data-live="{{=ev[20]}}"
                    data-event="{{=ev[0]}}"
                    data-league-id="{{=leagueId}}"
                    data-home-team="{{=ev[1]}}"
                    data-away-team="{{=ev[2]}}"
                    data-sport-name="{{=sportName}}"
                  >
                      {{? !(ev[27] && ev[27].toLowerCase() === 'regular' && parseInt(p) === 0 && isLiveEvent) }}
                          <div class="grading-unit-container">
                              <span class="period-name">({{=getPeriodsName(periodsDescription, sp[0], p, false)}})<span>
                          </div>
                      {{?}}
                      <div class="team-name-container">
                        <span class='{{=(_sethdp && _sethdp[5] || _gameshdp && _gameshdp[5]) ? "favSel": "sel"}}' title="{{=teamNameEv1}}">
                            {{=teamNameEv1}}
                        </span>
                        <span class='{{=(_sethdp && _sethdp[6] || _gameshdp && _gameshdp[6]) ? "favSel": "sel"}}' title="{{=teamNameEv2}}">
                            {{=teamNameEv2}}
                        </span>
                      </div>
                      {{?hasDrawML && isMainLine}}
                          <span class="d">
                              {{=i18n("Draw")}}
                          </span>
                      {{?}}
                  </td>
                  <td class='col-1x2  main-1x2 border-bottom {{=statusPeriodLeftSide}}' data-eventid="{{=setEventId}}">
                  {{? !isSetEvent && (isRegularEvent || isRegularEventParent) && isMainLine && regular.length > 0 && regular[2]}}
                    <a class="odds {{=regular[2][1] < 0 ? 'fav neg' : ''}} regular"
                        data-oddsid="{{=regular[2][3]}}"
                        data-date="{{=ev[4]}}"
                        data-pl-res="{{=ev[22]}}"
                        data-team-type="{{=ev[11][0]}}"
                        id="{{=evSetsId}}|{{=p}}|1|0|{{=regular[2][4]?1:0}}|0"
                        >
                        {{? ot === OddsFormat.American}}
                            <span>{{? regular[2][1] > 0}}+{{?}}{{=regular[2][1]}}</span>                        
                        {{??}}
                            <span>{{=regular[2][1].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    <a class="odds {{=regular[2][0] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=regular[2][3]}}"
                        data-date="{{=ev[4]}}"
                        data-pl-res="{{=ev[22]}}"
                        data-team-type="{{=ev[11][1]}}"
                        id="{{=evSetsId}}|{{=p}}|1|1|{{=regular[2][4]?1:0}}|0"
                        >
                        {{? ot === OddsFormat.American}}
                            <span>{{? regular[2][0] > 0}}+{{?}}{{=regular[2][0]}}</span>                       
                        {{??}}
                            <span>{{=regular[2][0].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{? hasDrawML && regular[2][2] !== null}}
                        <a class="odds {{=regular[2][2] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=regular[2][3]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="2"
                            id="{{=evSetsId}}|{{=p}}|1|2|{{=regular[2][4]?1:0}}|0"
                            >
                            {{? ot === OddsFormat.American}}
                                <span>{{? regular[2][2] > 0}}+{{?}}{{=regular[2][2]}}</span>                       
                            {{??}}
                                <span>{{=regular[2][2].formatSeparators()}}</span>
                            {{?}}
                        </a>
                    {{?}}
                  {{??}}
                      {{? sets && sets[2] && sets[2][1] != '' && isMainLine}}
                        <a class="odds {{=sets[2][1] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=sets[2][3]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][0]}}"
                            id="{{=evSetsId}}|{{=p}}|1|0|{{=sets[2][4]?1:0}}|0"
                            >
                            {{? ot === OddsFormat.American}}
                                <span>{{? sets[2][1] > 0}}+{{?}}{{=sets[2][1]}}</span>                                           
                            {{??}}
                                <span>{{=sets[2][1].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        <a class="odds {{=sets[2][0] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=sets[2][3]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][1]}}"
                            id="{{=evSetsId}}|{{=p}}|1|1|{{=sets[2][4]?1:0}}|0"
                            >
                            {{? ot === OddsFormat.American}}
                                <span>{{? sets[2][0] > 0}}+{{?}}{{=sets[2][0]}}</span>                                         
                            {{??}}
                                <span>{{=sets[2][0].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{? hasDrawML && sets[2][2] !== null}}
                        <a class="odds {{=sets[2][2] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=sets[2][3]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="2"
                            id="{{=evSetsId}}|{{=p}}|1|2|{{=sets[2][4]?1:0}}|0"
                            >
                            {{? ot === OddsFormat.American}}
                                <span>{{? sets[2][2] > 0}}+{{?}}{{=sets[2][2]}}</span>                                             
                            {{??}}
                                <span>{{=sets[2][2].formatSeparators()}}</span>
                            {{?}}
                        </a>
                      {{?}}
                    {{?}}
                  {{?}}
                  </td>
                  <td class='col-hdp main-hdp border-bottom {{=statusPeriodLeftSide}}' data-eventid="{{=setEventId}}">
                      {{? _sethdp && _sethdp[2] != ''}}
                      <div class='hdp'>
                          <span>{{=_sethdp[5] || !_sethdp[6]  ? _sethdp[2].formatSeparators():'&nbsp;'}}</span>
                          <span>{{=_sethdp[6] ? _sethdp[2].formatSeparators():'&nbsp;'}}</span>
                      </div>
                      <div class='odds'>
                          <a class="odds {{=_sethdp[3] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_sethdp[7]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][0]}}"
                            id="{{=evSetsId}}|{{=p}}|2|0|{{=_sethdp[8]?1:0}}|{{=_sethdp[1]}}"
                            >
                              {{? ot === OddsFormat.American}}
                                  <span>{{? _sethdp[3] > 0}}+{{?}}{{=_sethdp[3]}}</span>                            
                              {{??}}
                                  <span>{{=_sethdp[3].formatSeparators()}}</span>
                              {{?}}
                          </a>
                          <a class="odds {{=_sethdp[4] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_sethdp[7]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][1]}}"
                            id="{{=evSetsId}}|{{=p}}|2|1|{{=_sethdp[8]?1:0}}|{{=_sethdp[0]}}"
                            >
                              {{? ot === OddsFormat.American}}
                                  <span>{{? _sethdp[4] > 0}}+{{?}}{{=_sethdp[4]}}</span>                            
                              {{??}}
                                  <span>{{=_sethdp[4].formatSeparators()}}</span>
                              {{?}}
                          </a>
                          {{? hasDrawML}}
                          <span></span>
                          {{?}}
                      </div>
                      {{?}}
                  </td>
                  <td class='col-ou  main-ou border-bottom-right {{=statusPeriodLeftSide}}' data-eventid="{{=setEventId}}">
                      {{? _setou && _setou[0] != ''}}
                      <div class='hdp'>
                          <span>{{=_setou[0].formatSeparators()}}</span>
                          <span>{{=i18n('u')}}</span>
                      </div>
                      <div class='odds'>
                          <a class="odds {{=_setou[2] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_setou[4]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][0]}}"
                            id="{{=evSetsId}}|{{=p}}|3|3|{{=_setou[5]?1:0}}|{{=_setou[1]}}"
                            >
                              {{? ot === OddsFormat.American}}
                                  <span>{{? _setou[2] > 0}}+{{?}}{{=_setou[2]}}</span>
                              {{??}}
                                  <span>{{=_setou[2].formatSeparators()}}</span>
                              {{?}}
                          </a>
                          <a class="odds {{=_setou[3] < 0 ? 'fav neg' : ''}}"
                            data-oddsid="{{=_setou[4]}}"
                            data-date="{{=ev[4]}}"
                            data-pl-res="{{=ev[22]}}"
                            data-team-type="{{=ev[11][1]}}"
                            id="{{=evSetsId}}|{{=p}}|3|4|{{=_setou[5]?1:0}}|{{=_setou[1]}}"
                            >
                              {{? ot === OddsFormat.American}}
                                  <span>{{? _setou[3] > 0}}+{{?}}{{=_setou[3]}}</span>
                              {{??}}
                                  <span>{{=_setou[3].formatSeparators()}}</span>
                              {{?}}
                          </a>
                          {{? hasDrawML}}
                          <span></span>
                          {{?}}
                      </div>
                      {{?}}
                  </td>
                      <td class="col-1x2 main-1x2 border-bottom {{=statusPeriodRightSide}}" data-bt="1" data-period="={{=p}}" isAlt="{{=_gameshdp[8]}}" data-eventid="{{=gameEventId}}">
                          {{? games && games[2] && games[2][1] != '' && isMainLine && !isRegularEvent}}
                          <a class="odds {{=games[2][1] < 0 ? 'fav neg' : ''}}"
                          data-oddsid="{{=games[2][3]}}"
                          data-date="{{=ev[4]}}"
                          data-pl-res="{{=ev[22]}}"
                          data-team-type="{{=ev[11][0]}}"
                          id="{{=ev[0]}}|{{=p}}|1|0|{{=games[2][4]?1:0}}|0"
                          >
                              {{? ot === OddsFormat.American}}
                                  <span>{{? games[2][1] > 0}}+{{?}}{{=games[2][1]}}</span>
                              {{??}}
                                  <span>{{=games[2][1].formatSeparators()}}</span>
                              {{?}}
                          </a>
                          <a class="odds {{=games[2][0] < 0 ? 'fav neg' : ''}}"
                          data-oddsid="{{=games[2][3]}}"
                          data-date="{{=ev[4]}}"
                          data-pl-res="{{=ev[22]}}"
                          data-team-type="{{=ev[11][1]}}"
                          id="{{=ev[0]}}|{{=p}}|1|1|{{=games[2][4]?1:0}}|0"
                          >
                              {{? ot === OddsFormat.American}}
                                  <span>{{? games[2][0] > 0}}+{{?}}{{=games[2][0]}}</span>                       
                              {{??}}
                                  <span>{{=games[2][0].formatSeparators()}}</span>
                              {{?}}
                          </a>
                          {{? hasDrawML && games[2][2] !== null}}
                          <a class="odds {{=games[2][2] < 0 ? 'fav neg' : ''}}"
                          data-oddsid="{{=games[2][3]}}"
                          data-date="{{=ev[4]}}"
                          data-pl-res="{{=ev[22]}}"
                          data-team-type="2"
                          id="{{=ev[0]}}|{{=p}}|1|2|{{=games[2][4]?1:0}}|0"
                          >
                              {{? ot === OddsFormat.American}}
                                  <span>{{? games[2][2] > 0}}+{{?}}{{=games[2][2]}}</span>                       
                              {{??}}
                                  <span>{{=games[2][2].formatSeparators()}}</span>
                              {{?}}
                          </a>
                          {{?}}
                          {{?}}
                      </td>
                      
                      <td class='col-hdp main-hdp border-bottom {{=statusPeriodRightSide}}' data-bt="2" data-period="{{=p}}" data-eventid="{{=gameEventId}}">
                          {{? _gameshdp && _gameshdp[2] != ''}}
                          <div class='hdp'>
                              <span>{{=_gameshdp[5] || !_gameshdp[6]  ? _gameshdp[2].formatSeparators():'&nbsp;'}}</span>
                              <span>{{=_gameshdp[6] ? _gameshdp[2].formatSeparators():'&nbsp;'}}</span>
                          </div>
                          <div class='odds'>
                              <a class="odds {{=_gameshdp[3] < 0 ? 'fav neg' : ''}}"
                              data-oddsid="{{=_gameshdp[7]}}"
                              data-date="{{=ev[4]}}"
                              data-pl-res="{{=ev[22]}}"
                              data-team-type="{{=ev[11][0]}}"
                              id="{{=ev[0]}}|{{=p}}|2|0|{{=_gameshdp[8]?1:0}}|{{=_gameshdp[1]}}"
                              >
                                  {{? ot === OddsFormat.American}}
                                      <span>{{? _gameshdp[3] > 0}}+{{?}}{{=_gameshdp[3]}}</span>
                                  {{??}}
                                      <span>{{=_gameshdp[3].formatSeparators()}}</span>
                                  {{?}}
                              </a>
                              <a class="odds {{=_gameshdp[4] < 0 ? 'fav neg' : ''}}"
                              data-oddsid="{{=_gameshdp[7]}}"
                              data-date="{{=ev[4]}}"
                              data-pl-res="{{=ev[22]}}"
                              data-team-type="{{=ev[11][1]}}"
                              id="{{=ev[0]}}|{{=p}}|2|1|{{=_gameshdp[8]?1:0}}|{{=_gameshdp[0]}}"
                              >
                                  {{? ot === OddsFormat.American}}
                                      <span>{{? _gameshdp[4] > 0}}+{{?}}{{=_gameshdp[4]}}</span>                                
                                  {{??}}
                                      <span>{{=_gameshdp[4].formatSeparators()}}</span>
                                  {{?}}
                              </a>
                              {{? hasDrawML}}
                              <span></span>
                              {{?}}
                          </div>
                          {{?}}
                      </td>
                      <td class='col-ou main-ou border-bottom {{=statusPeriodRightSide}}' data-eventid="{{=gameEventId}}">
                          {{? _gamesou && _gamesou[2] != ''}}
                          <div class='hdp'>
                              <span>{{=_gamesou[0].formatSeparators()}}</span>
                              <span>{{=i18n('u')}}</span>
                          </div>
                          <div class='odds'>
                              <a class="odds {{=_gamesou[2] < 0 ? 'fav neg' : ''}}"
                              data-oddsid="{{=_gamesou[4]}}"
                              data-date="{{=ev[4]}}"
                              data-pl-res="{{=ev[22]}}"
                              data-team-type="{{=ev[11][0]}}"
                              id="{{=ev[0]}}|{{=p}}|3|3|{{=_gamesou[5]?1:0}}|{{=_gamesou[1]}}"
                              >
                                  {{? ot === OddsFormat.American}}
                                      <span>{{? _gamesou[2] > 0}}+{{?}}{{=_gamesou[2]}}</span>
                                  {{??}}
                                      <span>{{=_gamesou[2].formatSeparators()}}</span>
                                  {{?}}
                              </a>
                              <a class="odds {{=_gamesou[3] < 0 ? 'fav neg' : ''}}"
                              data-oddsid="{{=_gamesou[4]}}"
                              data-date="{{=ev[4]}}"
                              data-pl-res="{{=ev[22]}}"
                              data-team-type="{{=ev[11][1]}}"
                              id="{{=ev[0]}}|{{=p}}|3|4|{{=_gamesou[5]?1:0}}|{{=_gamesou[1]}}"
                              >
                                  {{? ot === OddsFormat.American}}
                                      <span>{{? _gamesou[3] > 0}}+{{?}}{{=_gamesou[3]}}</span>
                                  {{??}}
                                      <span>{{=_gamesou[3].formatSeparators()}}</span>
                                  {{?}}
                              </a>
                              {{? hasDrawML}}
                              <span></span>
                              {{?}}
                          </div>
                          {{?}}
                      </td>
                  {{?line_index == 0}}
                      <td class='col-more main-more {{=(numberOfDisplayedLine == line_index) ? "border-bottom-right" : "border-right"}} border-left col-border-right' total-lines='{{=lines.length}}' rowspan='{{=(numberOfDisplayedLine == 0) ? 1 : numberOfDisplayedLine}}'>
                      <div class='more-content'>
                          {{? !isBlockedLiveSport && !isBlockedLiveLeague}}
                              {{? ev[18] && isBrandSupportLiveCenter}}
                              <!-- Has live center -->
                                  <span class="icons live-center-icon">
                                      <i class="live-ct"
                                      data-live="{{=ev[20]}}"
                                      data-event="{{=ev[0]}}"
                                      data-league-id="{{=leagueId}}"
                                      data-home-team="{{=ev[1]}}"
                                      data-away-team="{{=ev[2]}}"
                                      data-sport-name="{{=sportName}}"
                                      data-league-name="{{=leagueName}}"
                                      >
                                      </i>
                                      <div class="custom-tooltip">
                                      <div class="tooltip-wrapper">
                                          <a id="{{=TooltipActions.SIGNIN}}" class="tooltip-link">{{=i18n('Sign in')}}</a>
                                          {{? isEnableSignUp}}
                                          <span class="tooltip-text">{{=i18n('or')}}</span>
                                          <a id="{{=TooltipActions.SIGNUP}}" class="tooltip-link">{{=i18n('Sign up')}}</a>
                                          {{?}}
                                          <span class="tooltip-text">{{=i18n('to access our Live Center')}}</span>
                                      </div>
                                      </div>
                                  </span>
                              {{?}}
                              {{? isShowLiveTv && ev[19] }}
                              <!-- Has live tv -->
                                  <span class="icons live-tv-icon">
                                      <i class="live-tv"
                                      data-live="{{=ev[20]}}"
                                      data-event="{{=ev[0]}}"
                                      data-league-id="{{=leagueId}}"
                                      data-home-team="{{=ev[1]}}"
                                      data-away-team="{{=ev[2]}}"
                                      data-sport-name="{{=sportName}}"
                                      >
                                      </i>
                                      <div class="custom-tooltip">
                                      <div class="tooltip-wrapper">
                                          <a id="{{=TooltipActions.SIGNIN}}" class="tooltip-link">{{=i18n('Sign in')}}</a>
                                          <span class="tooltip-text">{{=i18n('to access our Live TV')}}</span>
                                      </div>
                                      </div>
                                  </span>
                              {{?}}
                          {{?}}
                          {{? _moreBetsCount > 0}}
                              <span id='more_{{=evParent && evParent[0] && evParent[0] != ev[0] ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}' class='more' data-eid="{{=evParent && evParent[0] && evParent[0] != ev[0] ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}" data-pid="{{=p}}">
                                  <span class='more-loading'><i class='fa fa-sync fa-spin'></i></span>
                                  <span class='sign'>+</span>
                                  <span class="more-count">
                                      {{=_moreBetsCount}}
                                  </span>
                              </span>
                          {{?}}
                      </div>
                      </td>
                    {{?}}
                </tr>
              {{?}}
              {{~}}
              <tr class="more-bets tennis-more-bets {{=parentEventIndex%2==0?"odd":"even"}}" id="e{{=evParent && evParent[0] && evParent[0] != ev[0] ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}_more"><td colspan="12" class="more-bets tennis-more-bets"></td></tr>
          </table>
        {{~}}
        {{? isLastestEvent && hasMatchPeriod}}
            <div class="tennis-more-events border-bottom-right border-left {{=parentEventIndex%2==0?"odd":"even"}} pe{{=ev[28]}}">
                <div class="tennis-more-events-btn" data-event-parent-id={{=ev[28]}}>
                    <span class="show-less pe{{=ev[28]}} hide">
                        {{=i18n("See less")}}
                        <i class='fas fa-chevron-up'></i>
                    </span>
                    <span class="show-more pe{{=ev[28]}}">
                        {{=i18n("See more")}}
                        <i class='fas fa-chevron-down'></i>
                    </span>
                </div>
                <div class="more-market-custom-tooltip">
                    <div class="tooltip-wrapper">
                        <i class="fal fa-times close tooltip-close"></i>
                        <div class="tooltip-title">{{=i18n('More Market Types')}}</div>
                        <div class="tooltip-content">{{=i18n('Click to see more market types.')}}</div>
                    </div>
                </div>
            </div>
        {{?}}
      {{~}}
    {{~}}
    </div>
    {{~}}
    {{? leagues.length ==0}}
        <div class="no-event border-bottom-right border-left">{{=i18n('No Events')}}</div>
    {{?}}
    </div>
    {{~}}
    {{?}}
`;


// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisHdpDouble.js